/* eslint-disable no-template-curly-in-string */
/* eslint-disable camelcase */
import * as yup from 'yup';
import {
  setLocale,
} from '../../../../../utils/yup-utils';

setLocale();

const validationRules = {
  filter_clinic: yup.string().nullable(),
};

const validate = async (form) => {
  const schema = await yup.object().shape(validationRules);

  try {
    const data = await schema.validate(form, { abortEarly: false });
    return { isValid: true, data, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner) {
      err.inner.forEach((error) => { errors[error.path] = error.message; });
    }
    return { isValid: false, data: form, errors };
  }
};

export default validate;
